(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2kit-custom"] && !Shopify.designMode) return;
  try {
    
  
        // Handle form submissions with spinner
        document.addEventListener('DOMContentLoaded', function() {
            // Handle all buy button forms
            const buyForms = document.querySelectorAll('product-form form');
            
            buyForms.forEach(form => {
                form.addEventListener('submit', function(e) {
                    const button = this.querySelector('button[type="submit"]');
                    if (button && !button.classList.contains('loading')) {
                        button.classList.add('loading');
                        button.disabled = true;
                        
                        // Re-enable after 3 seconds as fallback
                        setTimeout(() => {
                            button.classList.remove('loading');
                            button.disabled = false;
                        }, 2000);
                    }
                });
            });
        });

        // Carousel functionality
  const carouselContainer = document.querySelector('.bundle-carousel-container');
  const carouselItems = document.querySelectorAll('.carousel-item');
  const prevBtn = document.querySelector('.carousel-nav-left');
  const nextBtn = document.querySelector('.carousel-nav-right');
  const dots = document.querySelectorAll('.dot');
  
  if (!carouselContainer || !prevBtn || !nextBtn) return;

  let currentIndex = 0;
  const totalItems = carouselItems.length;

  function updateCarousel(index) {
    const itemWidth = carouselItems[0].offsetWidth;
    const gap = window.innerWidth >= 1024 ? 40 : 20;
    const scrollPosition = (itemWidth + gap) * index;
    
    carouselContainer.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });

    // Update dots
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });

    // Update button states
    prevBtn.style.opacity = index === 0 ? '0.5' : '1';
    prevBtn.style.pointerEvents = index === 0 ? 'none' : 'auto';
    
    const maxIndex = window.innerWidth >= 1024 ? totalItems - 2 : totalItems - 1;
    nextBtn.style.opacity = index >= maxIndex ? '0.5' : '1';
    nextBtn.style.pointerEvents = index >= maxIndex ? 'none' : 'auto';

    currentIndex = index;
  }

  prevBtn.addEventListener('click', () => {
    if (currentIndex > 0) {
      updateCarousel(currentIndex - 1);
    }
  });

  nextBtn.addEventListener('click', () => {
    const maxIndex = window.innerWidth >= 1024 ? totalItems - 2 : totalItems - 1;
    if (currentIndex < maxIndex) {
      updateCarousel(currentIndex + 1);
    }
  });

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      updateCarousel(index);
    });
  });

  // Touch swipe support
  let touchStartX = 0;
  let touchEndX = 0;

  carouselContainer.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  carouselContainer.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    const maxIndex = window.innerWidth >= 1024 ? totalItems - 2 : totalItems - 1;
    if (touchEndX < touchStartX - 50 && currentIndex < maxIndex) {
      updateCarousel(currentIndex + 1);
    }
    if (touchEndX > touchStartX + 50 && currentIndex > 0) {
      updateCarousel(currentIndex - 1);
    }
  }

  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateCarousel(currentIndex);
    }, 150);
  });

  // Initialize
  updateCarousel(0);
        function toggleShipping() {
            const content = document.getElementById('shippingContent');
            content.style.display = content.style.display === 'block' ? 'none' : 'block';
        }

        // Carousel functionality
        document.addEventListener('DOMContentLoaded', function() {
            const container = document.querySelector('.carousel-container');
            const items = document.querySelectorAll('.carousel-item');
            const prevBtn = document.querySelector('.carousel-nav-left');
            const nextBtn = document.querySelector('.carousel-nav-right');
            const dots = document.querySelectorAll('.dot');
            
            let currentIndex = 0;
            const totalItems = items.length;

            function updateCarousel(index) {
                const itemWidth = items[0].offsetWidth;
                const gap = 20;
                const scrollPosition = (itemWidth + gap) * index;
                
                container.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                });

                dots.forEach((dot, i) => {
                    dot.classList.toggle('active', i === index);
                });

                prevBtn.classList.toggle('disabled', index === 0);
                
                const maxIndex = window.innerWidth >= 1024 ? Math.max(0, totalItems - 3) : 
                                window.innerWidth >= 768 ? Math.max(0, totalItems - 2) : totalItems - 1;
                nextBtn.classList.toggle('disabled', index >= maxIndex);

                currentIndex = index;
            }

            prevBtn.addEventListener('click', () => {
                if (currentIndex > 0) {
                    updateCarousel(currentIndex - 1);
                }
            });

            nextBtn.addEventListener('click', () => {
                const maxIndex = window.innerWidth >= 1024 ? Math.max(0, totalItems - 3) : 
                                window.innerWidth >= 768 ? Math.max(0, totalItems - 2) : totalItems - 1;
                if (currentIndex < maxIndex) {
                    updateCarousel(currentIndex + 1);
                }
            });

            dots.forEach((dot, index) => {
                dot.addEventListener('click', () => {
                    updateCarousel(index);
                });
            });

            // Touch swipe support
            let touchStartX = 0;
            let touchEndX = 0;

            container.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            });

            container.addEventListener('touchend', (e) => {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            });

            function handleSwipe() {
                const maxIndex = window.innerWidth >= 1024 ? Math.max(0, totalItems - 3) : 
                                window.innerWidth >= 768 ? Math.max(0, totalItems - 2) : totalItems - 1;
                if (touchEndX < touchStartX - 50 && currentIndex < maxIndex) {
                    updateCarousel(currentIndex + 1);
                }
                if (touchEndX > touchStartX + 50 && currentIndex > 0) {
                    updateCarousel(currentIndex - 1);
                }
            }

            // Handle window resize
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    updateCarousel(Math.min(currentIndex, totalItems - 1));
                }, 150);
            });

            updateCarousel(0);
        });

    
  } catch(e) { console.error(e); }
})();
})();
